
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar } from "@/components/ui/calendar";
import { CalendarIcon } from "lucide-react";
import { startOfDay, isBefore } from "date-fns";
import { useIsMobile } from "@/hooks/use-mobile";

interface BookingDateSelectionProps {
  selectedDate?: Date;
  onSelectDate: (date: Date | undefined) => void;
  onDateSelected?: () => void; // Callback for when date is selected on mobile
}

const BookingDateSelection = ({ selectedDate, onSelectDate, onDateSelected }: BookingDateSelectionProps) => {
  const isMobile = useIsMobile();

  const handleDateSelect = (date: Date | undefined) => {
    onSelectDate(date);
    
    // On mobile, trigger the scroll callback after a short delay to allow state to update
    if (isMobile && date && onDateSelected) {
      setTimeout(() => {
        onDateSelected();
      }, 100);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <CalendarIcon className="h-5 w-5" />
          <span>Select Date</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={handleDateSelect}
          disabled={(date) => isBefore(startOfDay(date), startOfDay(new Date()))}
          className="rounded-md border pointer-events-auto"
        />
      </CardContent>
    </Card>
  );
};

export default BookingDateSelection;
